import React, {useEffect} from 'react';
import {useNavigate, useLocation} from "react-router-dom";
import * as qs from 'qs';
import {useValidateCompanyInviteTokenQuery} from "apis/companiesApi";
import AuthLayout from "layouts/AuthLayout";
import RegisterForm from "pages/Register/RegisterForm";
import LoginForm from "pages/Login/LoginForm";
import {useDispatch} from "react-redux";
import {inviteTokenReceived} from "redux/slices/authenticationSlice";

const CompanyInvitationPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const queries = qs.parse(location.search.replace('?',''));
    const token = queries.token;
    const {data, error, isFetching, refetch} = useValidateCompanyInviteTokenQuery({token});

    useEffect(() => {
        if(token) {
            dispatch(inviteTokenReceived(token));
        }
    }, [token, dispatch])


    const onLoginSuccess = () => {
        navigate(`/auth/company-invitation-confirmation`);
    }

    return (
        <AuthLayout>
            <div className="company-invite-page">
                {isFetching ? (
                    <>Validating...</>
                ) : error ? (
                    <>{error.data?.message || "System error occurred.  Please try again later"}</>
                ) : data.register ? (
                    <>
                        <h5>Complete the following form to join the BusinessScape Management Platform</h5>
                        <RegisterForm
                            email={data.email}
                            token={token}
                            onRegisterSuccess={refetch} />
                    </>
                ) : (
                    <>
                        <h5>Use your newly created BusinessScape login to access the management platform</h5>
                        <LoginForm
                            onLoginSuccess={onLoginSuccess} />
                    </>
                )}
            </div>
        </AuthLayout>);
}

export default CompanyInvitationPage;
